/**
 * @generated SignedSource<<2e4debde7b9153e871a75686f2dac1b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SyntheticActionItemGroupsListMoveItemMutation$variables = {
  noteBlockId: string;
  orderInsertedAfter?: string | null;
  orderInsertedBefore?: string | null;
};
export type SyntheticActionItemGroupsListMoveItemMutation$data = {
  readonly moveActionItem: {
    readonly updatedBlock: {
      readonly id: string;
      readonly userOrder: string;
    };
  } | null;
};
export type SyntheticActionItemGroupsListMoveItemMutation$rawResponse = {
  readonly moveActionItem: {
    readonly updatedBlock: {
      readonly id: string;
      readonly userOrder: string;
    };
  } | null;
};
export type SyntheticActionItemGroupsListMoveItemMutation = {
  rawResponse: SyntheticActionItemGroupsListMoveItemMutation$rawResponse;
  response: SyntheticActionItemGroupsListMoveItemMutation$data;
  variables: SyntheticActionItemGroupsListMoveItemMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteBlockId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderInsertedAfter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderInsertedBefore"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "noteBlockId",
        "variableName": "noteBlockId"
      },
      {
        "kind": "Variable",
        "name": "orderInsertedAfter",
        "variableName": "orderInsertedAfter"
      },
      {
        "kind": "Variable",
        "name": "orderInsertedBefore",
        "variableName": "orderInsertedBefore"
      }
    ],
    "concreteType": "MoveActionItem",
    "kind": "LinkedField",
    "name": "moveActionItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "updatedBlock",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userOrder",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SyntheticActionItemGroupsListMoveItemMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "SyntheticActionItemGroupsListMoveItemMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "0bf31e976bbe368540ec077f3e701183",
    "id": null,
    "metadata": {},
    "name": "SyntheticActionItemGroupsListMoveItemMutation",
    "operationKind": "mutation",
    "text": "mutation SyntheticActionItemGroupsListMoveItemMutation(\n  $noteBlockId: ID!\n  $orderInsertedBefore: String\n  $orderInsertedAfter: String\n) {\n  moveActionItem(noteBlockId: $noteBlockId, orderInsertedBefore: $orderInsertedBefore, orderInsertedAfter: $orderInsertedAfter) {\n    updatedBlock {\n      id\n      userOrder\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa6bcbf8b211633067a5dd11935e3508";

export default node;
